import { axios } from "./http.js";

export const addProduct = params => {
  return axios.post("/product/", params);
};
// 分页查询指定分类的产品列表;
export const getProductList = params =>
  axios.get(
    `/product/list/${params.categoryId}/${params.pageNo}/${params.pageSize}`
  );

export const deleteProduct = id => {
  return axios.delete(`/product/${id}`);
};

export const putProduct = params => {
  return axios.put(`/product/${params.id}`, params);
};
export const getProduct = id => axios.get(`/product/${id}`);
